import { FunctionComponent } from 'react';

import { IconEllipses } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { Typography } from 'omakase';
import AchievementCircle from 'components/profile/achievements/AchievementCircle';
import IconMenuVertical from 'components/icons/svgr/IconMenuVertical';

export interface Props {
  nOverflowElements: number;
  onClick(): void;
}

const OverflowButton: FunctionComponent<Props> = ({ nOverflowElements, onClick }) => {
  return (
    <button className="Achievement_button" onClick={onClick} aria-label="View all achievements">
      <AchievementCircle className="Achievement-overflow">
        {nOverflowElements > 0 ? (
          <Typography color="inherit" component="span" variant="body02">
            <b>{`+${nOverflowElements}`}</b>
          </Typography>
        ) : (
          <IconMigrationUtil
            newIcon={<IconEllipses fontSize="small" />}
            legacyIcon={
              <IconMenuVertical style={{ transform: 'rotate(90deg)' }} width={18} height={18} />
            }
          />
        )}
      </AchievementCircle>
    </button>
  );
};

export default OverflowButton;
